import { render, staticRenderFns } from "./ApSummary.vue?vue&type=template&id=50ab6215&"
import script from "./ApSummary.vue?vue&type=script&lang=ts&"
export * from "./ApSummary.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports